import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { Route } from 'react-router-dom';
import { FeesForecastDashboard } from './entities/dsaForecast/FeesForecastDashboard';
import { UcbInctvClaimDashboard } from './entities/inctvClaimDashboard/UcbInctvClaimDashboard';

const ucbScRoutes = [
  <Route path="/sc/dashboard/inctv-claim" element={<UcbInctvClaimDashboard />} />,
  <Route path="/sc/dashboard/fees-forecast" element={<FeesForecastDashboard />} />,
  <Route path="/sc/mcd-claim-line" element={<EntityView />} />
]

export default ucbScRoutes;